<script>
import { mapState } from "vuex";
import VFooter from "@/components/footer/VFooter";
import QuestionPopup from "@/components/QuestionPopup/index";
import ConfirmBuyDialog from "./components/ConfirmBuyDialog";
import PasswordDialog from "./components/PasswordDialog";
import ChargingDialog from "@/views/wallet/components/ChargingDialog";
import ChargingHKDDialog from "@/views/wallet/components/ChargingHKDDialog";
export default {
  components: {
    VFooter,
    QuestionPopup,
    ConfirmBuyDialog,
    PasswordDialog,
    ChargingDialog,
    ChargingHKDDialog,
  },
  data() {
    return {
      detailData: {
        projectName: "",
        saleAssetType: "",
        saleType: 1,
        status: 1,
        priceUsd: 0,
        issueUsdPrice: 0,
        saleTotalAmount: 0,
        preSaleAmount: 0,
        saleTotalValue: 0,
        startTime: "",
        endTime: "",
        distributionStartTime: "",
        distributionEndTime: "",
        planTradeTime: "",
        minBuyShares: 0,
        maxBuyShares: 0,
        soldShares: 0,
        availableShares: 0,
        userBoughtShares: 0,
        buySharesMax: 0,
        minBuyAmount: 0,
        maxBuyAmount: 0,
        description: "",
        icon: "",
        posterUrl: "",
        saleDisplayStatus: "",
        saleDisplayStatusText: "",
        statusTime: "",
        statusTimeType: "",
        protocol: "",
        contractAddress: "",
        whitepaperUrl: "",
        explorerUrl: "",
        network: "",
        blockchain: "",
        issueAmount: 0,
        perShareAssetAmount: 0,
        flagWhitelist: 0,
        whitelist: null,
      },
      countdown: 0,
      countdownText: "",
      timer: null,
      isLoggedIn: false,
      currentOrderNo: "",
      currentPayAssetType: "",
      currentAsset: null,
    };
  },
  computed: {
    ...mapState(["user", "errorCode"]),
    isOnline() {
      return this.detailData.saleDisplayStatus === "online";
    },
    isEnded() {
      return this.detailData.saleDisplayStatus === "ended";
    },
    isNotStarted() {
      return this.detailData.saleDisplayStatus === "not_started";
    },
    isNonWhitlist() {
      return (
        this.detailData.flagWhitelist === 1 &&
        (!this.detailData.whitelist ||
          this.detailData.whitelist.status !== "enabled")
      );
    },
    isHasWhitlist() {
      return this.detailData.flagWhitelist === 1 && this.detailData.whitelist;
    },
    isExceedMaxBuyShares() {
      return this.detailData.buySharesMax <= 0;
    },
    canBuyNow() {
      return this.isLoggedIn && this.isOnline;
    },
    soldPercent() {
      const total = this.detailData.totalShares || 0;
      const sold = this.detailData.soldShares || 0;
      if (total === 0) return 0;
      return Math.round((sold / total) * 100);
    },
  },
  created() {
    this.isLoggedIn = !!localStorage.getItem("jwt-token");

    if (!this.$route.query.projectId) return;
    this.$axios
      .post("/mall/project/detail", {
        projectId: this.$route.query.projectId,
      })
      .then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.detailData = { ...this.detailData, ...res.data.data };
          this.initData();
        }
      });
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    goBack() {
      // 有历史记录则返回上一页，否则兜底跳 /mall
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push({ path: "/mall" });
      }
    },
    initData() {
      if (this.detailData.statusTime) {
        this.startCountdown();
      }
    },
    formatDateTime(time) {
      if (!time) return " -- ";
      const date = new Date(time);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const seconds = date.getSeconds().toString().padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formatNumber(num) {
      if (!num && num !== 0) return "-";
      return Number(num).toLocaleString();
    },
    startCountdown() {
      const updateCountdown = () => {
        if (this.detailData.statusTime) {
          const targetTime = new Date(this.detailData.statusTime).getTime();
          const now = new Date().getTime();
          const diff = targetTime - now;

          if (diff > 0) {
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor(
              (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
            );
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            if (days > 0) {
              this.countdownText = `${days}${this.$t(
                "mallDetail.day",
              )}${hours}${this.$t("mallDetail.hour")}${minutes}${this.$t(
                "mallDetail.minute",
              )}${seconds}${this.$t("mallDetail.second")}`;
            } else {
              this.countdownText = `${hours}${this.$t(
                "mallDetail.hour",
              )}${minutes}${this.$t("mallDetail.minute")}${seconds}${this.$t(
                "mallDetail.second",
              )}`;
            }
          } else {
            if (this.detailData.statusTimeType === "end") {
              this.countdownText = this.$t("mallDetail.ended");
            } else {
              this.countdownText = this.$t("mallDetail.started");
            }
            if (this.timer) {
              clearInterval(this.timer);
            }
          }
        }
      };

      updateCountdown();
      this.timer = setInterval(updateCountdown, 1000);
    },
    getStatusClass(displayStatus) {
      const classMap = {
        online: "selling",
        not_started: "pending",
        ended: "ended",
      };
      return classMap[displayStatus] || "";
    },
    handleBuy() {
      if (this.isEnded) {
        return;
      }
      if (!this.isLoggedIn) {
        this.goLogin();
        return;
      }
      if (!this.isOnline) {
        return;
      }
      this.toBuy();
    },
    toBuy() {
      this.$refs.confirmBuyDialog.open();
    },
    async handleConfirmBuy(params) {
      try {
        const createRes = await this.$axios.post("/mall/order/create", {
          projectId: params.projectId,
          shares: params.shares,
        });
        if (createRes.data.code === this.errorCode.ok) {
          this.currentOrderNo = createRes.data.data.orderNo;
          this.currentPayAssetType = params.payAssetType;
          this.$refs.passwordDialog.open();
        } else {
          if (
            createRes.data.code === "MALL015" ||
            createRes.data.code === "MALL016"
          ) {
            let orderStatus =
              createRes.data.code === "MALL016" ? "pending_pay" : "";
            this.$confirm(createRes.data.msg, this.$t("confirmBuy.tip"), {
              confirmButtonText: this.$t("confirmBuy.goto"),
              cancelButtonText: this.$t("cancel"),
              type: "warning",
            })
              .then(() => {
                this.$router.push({
                  path: "/user",
                  query: { type: 7, status: orderStatus },
                });
              })
              .catch(() => {});
          } else {
            this.$message.error(
              createRes.data.msg || this.$t("confirmBuy.order_create_fail"),
            );
          }
        }
      } catch (error) {
        this.$message.error(this.$t("confirmBuy.order_create_fail"));
      }
    },
    handlePaySuccess(data) {
      this.$message.success(this.$t("confirmBuy.pay_success"));
      this.$router.push({
        path: "/user",
        query: { type: 7, status: "" },
      });

      console.log("------------------------", orderStatus);
    },
    handleConfirmBuyRecharge(methodValue) {
      const assetType = methodValue === "HKD" ? "HKD" : "USDT";
      this.currentAsset = {
        assetType: assetType,
        canRecharge: 1,
      };
      this.$nextTick(() => {
        if (methodValue === "HKD") {
          this.$refs.chargingHKDDialogRef.init(this.currentAsset);
        } else {
          this.$refs.chargingDialogRef.init(this.currentAsset);
        }
      });
    },
    goLogin() {
      if (window.rwa) {
        window.rwa.login();
      } else {
        this.$router.push("/login");
      }
    },
    openUrl(url) {
      if (url) {
        window.open(url);
      }
    },
    copyAddress() {
      const address = this.detailData.contractAddress;
      if (address) {
        navigator.clipboard
          .writeText(address)
          .then(() => {
            this.$message.success(this.$t("mallDetail.copy_success"));
          })
          .catch(() => {
            this.$message.error(this.$t("mallDetail.copy_fail"));
          });
      }
    },
  },
};
</script>

<template>
  <div class="mall-box">
    <div class="back-box" @click="goBack">
      <img
        src="@/assets/img/images/icon/back-border.png"
        alt="back-border.png"
      />
      <p>{{ $t("mallDetail.title") }}</p>
    </div>

    <div class="main-content">
      <div class="grid-row-1">
        <div class="token-card">
          <div class="token-header">
            <div class="token-info">
              <img :src="detailData.icon" class="token-icon" />
              <div class="token-details">
                <div class="token-name-row">
                  <span class="token-name">{{ detailData.projectName }}</span>
                </div>
                <span
                  :class="[
                    'token-tag',
                    detailData.saleType === 1 ? 'pre-sale' : 'open-sale',
                  ]"
                >
                  {{
                    detailData.saleType === 1
                      ? $t("mall.pre_sale")
                      : $t("mall.open_sale")
                  }}
                </span>
                <span class="token-subtitle">{{
                  detailData.saleAssetType
                }}</span>
              </div>
            </div>
            <div v-if="isEnded" :class="['buy-btn', 'ended']">
              {{ $t("mallDetail.ended") }}
            </div>
            <div v-else-if="isNotStarted" :class="['buy-btn', 'countdown']">
              {{ countdownText || $t("mallDetail.waiting") }}
            </div>
            <div
              v-else-if="!isLoggedIn"
              :class="['buy-btn', 'login']"
              @click="goLogin"
            >
              {{ $t("mallDetail.please_login") }}
            </div>
            <div v-else-if="isNonWhitlist" :class="['buy-btn', 'login']">
              {{ $t("mallDetail.non_whitelist") }}
            </div>
            <div v-else-if="isExceedMaxBuyShares" :class="['buy-btn', 'login']">
              {{ $t("mallDetail.exceed_max_buy_shares") }}
            </div>
            <div v-else class="buy-btn" @click="handleBuy">
              {{ $t("mallDetail.buy_now") }}
            </div>
          </div>
          <div class="token-info-grid">
            <div class="info-col">
              <div class="info-row">
                <span class="info-label">{{
                  $t("mallDetail.issue_price")
                }}</span>
                <span class="info-value"
                  >{{ detailData.issueUsdPrice }} USD</span
                >
              </div>
              <div class="info-row">
                <span class="info-label">{{
                  $t("mallDetail.issue_amount")
                }}</span>
                <span class="info-value"
                  >{{ formatNumber(detailData.issueAmount) }}
                  {{ detailData.saleAssetType }}</span
                >
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t("mall.total_supply") }}</span>
                <span class="info-value"
                  >{{ formatNumber(detailData.totalShares) }}
                  {{ $t("mall.shares_unit") }}</span
                >
              </div>
            </div>
            <div class="info-col">
              <div class="info-row">
                <span class="info-label">{{ $t("mall.total_value") }}</span>
                <span class="info-value"
                  >$ {{ formatNumber(detailData.saleTotalValue) }}</span
                >
              </div>
              <div class="info-row">
                <span class="info-label">{{
                  $t("mallDetail.min_buy_shares")
                }}</span>
                <span class="info-value"
                  >{{ formatNumber(detailData.minBuyShares) }}
                  {{ $t("mall.shares_unit") }}</span
                >
              </div>
              <div class="info-row">
                <span class="info-label">{{
                  $t("mallDetail.max_buy_shares")
                }}</span>
                <span class="info-value"
                  >{{ formatNumber(detailData.maxBuyShares) }}
                  {{ $t("mall.shares_unit") }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="chain-card">
          <div class="chain-header">
            <span class="section-title">{{ $t("mallDetail.chain_info") }}</span>
            <span class="c-flex-center">
              <span
                v-if="detailData.whitepaperUrl"
                class="whitepaper-link"
                @click="openUrl(detailData.whitepaperUrl)"
                >{{ $t("mallDetail.view_whitepaper") }}</span
              >
              <i class="el-icon-arrow-right el-icon--right" />
            </span>
          </div>
          <div class="chain-info">
            <div class="chain-row">
              <span class="chain-label">{{ $t("mallDetail.network") }}</span>
              <span class="chain-value">{{
                detailData.network || " -- "
              }}</span>
            </div>
            <div class="chain-row">
              <span class="chain-label">{{ $t("mallDetail.blockchain") }}</span>
              <span class="chain-value">{{
                detailData.blockchain || " -- "
              }}</span>
            </div>
            <div class="chain-row">
              <span class="chain-label">{{ $t("mallDetail.protocol") }}</span>
              <span class="chain-value">{{
                detailData.protocol || " -- "
              }}</span>
            </div>
            <div class="chain-row">
              <span class="chain-label">{{
                $t("mallDetail.issue_amount")
              }}</span>
              <span class="chain-value"
                >{{ formatNumber(detailData.issueAmount) }}
                {{ detailData.saleAssetType }}</span
              >
            </div>
            <div class="chain-row">
              <span class="chain-label">{{
                $t("mallDetail.contract_address")
              }}</span>
              <div class="contract-wrap">
                <span class="chain-value truncate">{{
                  detailData.contractAddress || " -- "
                }}</span>
                <div
                  v-if="detailData.contractAddress"
                  class="copy-btn"
                  @click="copyAddress"
                >
                  {{ $t("mallDetail.copy") }}
                </div>
              </div>
            </div>
            <div class="chain-row">
              <span class="chain-label">{{ $t("mallDetail.explorer") }}</span>
              <span
                v-if="detailData.explorerUrl"
                class="chain-value link"
                @click="openUrl(detailData.explorerUrl)"
                >查看浏览器</span
              >
              <span v-else class="chain-value">-</span>
            </div>
          </div>
        </div>
      </div>

      <div
        :class="[
          'grid-row-2',
          isHasWhitlist ? 'has-whitelist' : 'no-whitelist',
        ]"
      >
        <div class="purchase-card">
          <div class="section-title">{{ $t("mallDetail.purchase_info") }}</div>
          <div class="purchase-info border-top">
            <div class="purchase-row">
              <span class="purchase-label">{{
                $t("mallDetail.max_subscription")
              }}</span>
              <div class="purchase-value-wrap">
                <span class="purchase-value"
                  >{{ detailData.maxBuyShares }}
                  {{ $t("mallDetail.share") }}</span
                >
                <span class="purchase-hint"
                  >(1 {{ $t("mallDetail.share") }} =
                  {{ detailData.perShareAssetAmount }}
                  {{ detailData.saleAssetType }})</span
                >
              </div>
            </div>
            <div class="purchase-row">
              <span class="purchase-label">{{
                $t("mallDetail.purchase_price")
              }}</span>
              <span class="purchase-value"
                >{{ detailData.priceUsd }} USD/{{
                  $t("mall.shares_unit")
                }}</span
              >
            </div>
            <div class="purchase-row">
              <span class="purchase-label">{{
                $t("mallDetail.protocol")
              }}</span>
              <span class="purchase-value">{{
                detailData.protocol || "--"
              }}</span>
            </div>
          </div>
        </div>

        <div class="whitelist-card" v-if="isHasWhitlist">
          <div class="section-title">{{ $t("mallDetail.whitelist_info") }}</div>
          <div class="whitelist-info">
            <div class="whitelist-row">
              <span class="whitelist-label">{{
                $t("mallDetail.whitelist_status")
              }}</span>
              <span
                :class="[
                  'whitelist-value',
                  detailData.whitelist.status === 'enabled'
                    ? 'enabled'
                    : 'disabled',
                ]"
              >
                {{
                  detailData.whitelist.status === "enabled"
                    ? $t("mallDetail.enabled")
                    : $t("mallDetail.disabled")
                }}
              </span>
            </div>
            <div class="whitelist-row">
              <span class="whitelist-label">{{
                $t("mallDetail.whitelist_max")
              }}</span>
              <span class="whitelist-value"
                >{{ detailData.whitelist.maxBuyShares }}
                {{ $t("mallDetail.share") }}</span
              >
            </div>
            <div class="whitelist-row">
              <span class="whitelist-label">{{
                $t("mallDetail.remaining_buy")
              }}</span>
              <span class="whitelist-value"
                >{{ detailData.buySharesMax }}
                {{ $t("mallDetail.share") }}</span
              >
            </div>
          </div>
        </div>

        <div class="time-card">
          <div class="time-item">
            <div class="time-dot blue"></div>
            <div class="time-info">
              <span class="time-label">{{
                $t("mallDetail.subscription_period")
              }}</span>
              <span class="time-value"
                >{{ formatDateTime(detailData.startTime) }} (UTC+8)</span
              >
            </div>
          </div>
          <div class="time-item">
            <div class="time-dot orange"></div>
            <div class="time-info">
              <span class="time-label">{{
                $t("mallDetail.distribution_start")
              }}</span>
              <span class="time-value"
                >{{
                  formatDateTime(detailData.distributionStartTime)
                }}
                (UTC+8)</span
              >
            </div>
          </div>
          <div class="time-item">
            <div class="time-dot orange"></div>
            <div class="time-info">
              <span class="time-label">{{
                $t("mallDetail.distribution_end")
              }}</span>
              <span class="time-value"
                >{{
                  formatDateTime(detailData.distributionEndTime)
                }}
                (UTC+8)</span
              >
            </div>
          </div>
          <div class="time-item">
            <div class="time-dot green"></div>
            <div class="time-info">
              <span class="time-label">{{
                $t("mallDetail.start_trading")
              }}</span>
              <span class="time-value">{{
                detailData.planTradeTime || " - "
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="image-card">
        <img v-if="detailData.posterUrl" :src="detailData.posterUrl" />
        <div class="rich-content" v-html="detailData.description || ''"></div>
      </div>
    </div>

    <VFooter />
    <QuestionPopup />

    <ConfirmBuyDialog
      ref="confirmBuyDialog"
      :project-info="detailData"
      @confirm="handleConfirmBuy"
      @recharge="handleConfirmBuyRecharge"
    />

    <ChargingDialog v-if="currentAsset" ref="chargingDialogRef" />
    <ChargingHKDDialog v-if="currentAsset" ref="chargingHKDDialogRef" />

    <PasswordDialog
      ref="passwordDialog"
      :order-no="currentOrderNo"
      :pay-asset-type="currentPayAssetType"
      @success="handlePaySuccess"
    />
  </div>
</template>

<style lang="less" scoped>
.mall-box {
  position: relative;
  background: var(--bg-color);
  min-height: 100vh;
  padding-bottom: 140px;

  .back-box {
    gap: 28px;
    display: flex;
    cursor: pointer;
    align-items: center;
    padding: 80px var(--spacing-60) 40px var(--spacing-60);

    img {
      width: 44px;
      height: 44px;
    }

    p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 32px;
      color: #333333;
    }
  }

  .main-content {
    padding: 30px var(--spacing-60);
    display: flex;
    flex-direction: column;
    gap: 24px;

    .grid-row-1 {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
    }

    .grid-row-2 {
      display: grid;
      gap: 24px;

      &.has-whitelist {
        grid-template-columns: repeat(3, 1fr);
      }

      &.no-whitelist {
        grid-template-columns: 1fr 2fr;
      }
    }
  }

  .token-card {
    background: #ffffff;
    padding: 24px;
    border-radius: 12px;
    position: relative;
    border: 1px solid var(--border-color);

    .token-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 20px;
      margin-bottom: 20px;
      padding-bottom: 16px;
      border-bottom: 1px solid var(--line-border-color);
    }

    .token-info {
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;
    }

    .token-icon {
      width: 48px;
      // height: 48px;
      margin-right: 16px;
      // border-radius: 8px;
      object-fit: cover;
      background-color: #ffffff;
    }

    .token-details {
      display: flex;
      flex-direction: column;
      gap: 6px;
      flex: 1;
      min-width: 0;
    }

    .token-name-row {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .token-name {
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .token-subtitle {
      font-size: 12px;
      color: #999999;
    }

    .token-tag {
      font-size: 10px;
      padding: 3px 8px;
      border-radius: 4px;
      border: 1px solid;
      flex-shrink: 0;
      font-weight: 500;
      width: fit-content;

      &.pre-sale {
        color: #07c160;
        border-color: #07c160;
        background-color: transparent;
      }

      &.open-sale {
        color: var(--primary-color);
        border-color: var(--primary-color);
        background-color: transparent;
      }
    }

    .buy-btn {
      // width: 100px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background-color: var(--primary-color);
      color: var(--white-color);
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      padding: 0 16px;

      &.ended {
        background-color: #f5f5f5;
        color: #cccccc;
        cursor: not-allowed;
      }

      &.countdown {
        background-color: #fff7e6;
        color: #ff8800;
      }

      &.login {
        background-color: #f0f5ff;
        color: var(--primary-color);
      }
    }

    .token-info-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0;

      .info-col {
        padding-left: 20px;
      }

      .info-col:first-child {
        padding-right: 20px;
        border-right: 1px solid var(--line-border-color);
      }
    }

    .info-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;
    }

    .info-label {
      font-size: 12px;
      color: #999999;
    }

    .info-value {
      font-size: 12px;
      color: #333333;
      font-weight: 500;
    }
  }

  .purchase-card,
  .whitelist-card,
  .chain-card {
    background: #ffffff;
    padding: 20px;
    border-radius: 12px;
    border: 1px solid var(--border-color);
  }

  .section-title {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
    margin-bottom: 16px;
    display: flex;
    align-items: center;

    &::before {
      content: "";
      width: 4px;
      height: 14px;
      background-color: var(--primary-color);
      border-radius: 2px;
      margin-right: 8px;
    }
  }
  .el-icon--right{
    font-size: 18px;
    color: var(--primary-color);
  }

  .chain-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    border-bottom: 1px solid var(--line-border-color);

    .whitepaper-link {
      font-size: 12px;
      color: var(--primary-color);
      cursor: pointer;
    }
  }

  .purchase-info,
  .whitelist-info,
  .chain-info {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .border-top {
    border-top: 1px solid var(--line-border-color);
  }

  .purchase-row,
  .whitelist-row,
  .chain-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
  }

  .purchase-row:first-child {
    padding-top: 10px;
  }

  .purchase-label,
  .whitelist-label,
  .chain-label {
    font-size: 12px;
    color: #999999;
  }

  .purchase-value,
  .whitelist-value,
  .chain-value {
    font-size: 12px;
    color: #333333;
    font-weight: 500;

    &.enabled {
      color: #07c160;
    }

    &.disabled {
      color: #ff4d4f;
    }

    &.truncate {
      max-width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &.link {
      color: var(--primary-color);
      cursor: pointer;
    }
  }

  .purchase-value-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
  }

  .purchase-hint {
    font-size: 13px;
    color: #999999;
  }

  .time-card {
    background: #ffffff;
    padding: 20px;
    border-radius: 12px;
    border: 1px solid var(--border-color);
    position: relative;

    .time-item {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      padding: 10px 0;
      position: relative;

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        padding-bottom: 0;
      }

      &:not(:last-child)::before {
        content: "";
        position: absolute;
        left: 5px;
        top: 22px;
        width: 2px;
        height: calc(100% - 10px);
        background-color: #e8e8e8;
      }

      &:not(:last-child) .time-dot.blue::after,
      &:not(:last-child) .time-dot.orange::after,
      &:not(:last-child) .time-dot.green::after {
        content: "";
        position: absolute;
        left: 5px;
        top: 22px;
        width: 2px;
        height: calc(100% - 10px);
        background-color: inherit;
        z-index: 1;
      }
    }

    .time-dot {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      margin-top: 2px;
      flex-shrink: 0;
      position: relative;
      z-index: 2;

      &.blue {
        background-color: var(--primary-color);
      }

      &.orange {
        background-color: #fa8c16;
      }

      &.green {
        background-color: #07c160;
      }
    }

    .time-info {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .time-label {
      font-size: 12px;
      color: #999999;
    }

    .time-value {
      font-size: 13px;
      color: #333333;
      font-weight: 500;
    }
  }

  .contract-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .copy-btn {
    font-size: 12px;
    color: var(--primary-color);
    padding: 4px 12px;
    border: 1px solid var(--primary-color);
    border-radius: 4px;
    cursor: pointer;
  }

  .image-card {
    padding: 20px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #f0f0f0;

    img {
      width: 100%;
      border-radius: 8px;
      margin-bottom: 16px;
      object-fit: cover;
    }

    .rich-content {
      /deep/ img {
        width: 100%;
        margin: 8px 0;
        border-radius: 6px;
      }

      /deep/ p {
        margin-bottom: 12px;
        line-height: 1.6;
        color: #666666;
        font-size: 13px;
      }

      /deep/ h1,
      /deep/ h2,
      /deep/ h3 {
        color: #333333;
        margin-top: 16px;
        margin-bottom: 8px;
        font-weight: 600;
        font-size: 14px;
      }

      /deep/ ul,
      /deep/ ol {
        padding-left: 20px;
        margin-bottom: 12px;
      }

      /deep/ li {
        margin-bottom: 6px;
        color: #666666;
        font-size: 13px;
      }
    }
  }
}
</style>
